import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-12 col-sm-5 col-md-4" }
const _hoisted_5 = { class: "col-lg-12 col-sm-5 col-md-4" }
const _hoisted_6 = { class: "col-lg-8" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-xxl-8" }
const _hoisted_9 = { class: "col-xxl-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TotalIncome = _resolveComponent("TotalIncome")!
  const _component_TotalExpenses = _resolveComponent("TotalExpenses")!
  const _component_StaticChart = _resolveComponent("StaticChart")!
  const _component_TransactionHistory = _resolveComponent("TransactionHistory")!
  const _component_DebitCard = _resolveComponent("DebitCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-lg-12 col-sm-2 col-md-4" }, [
            _createElementVNode("div", { style: {"margin-bottom":"61px"} }, [
              _createElementVNode("span", { class: "d-block mb-1" }, "Accounts Receivable"),
              _createElementVNode("h4", { class: "fs-20 mb-0" }, "$15,990")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_TotalIncome)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_TotalExpenses)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_StaticChart)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_TransactionHistory)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_DebitCard)
      ])
    ])
  ], 64))
}